<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center s4-login"
    id="page-login"
  >
    <div
      class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4 box-login"
    >
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col lg:block lg:w-1/2">
              <div class="logo-login mx-auto"></div>
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container content-login">
                <div class="vx-card__title mb-4">
                  <div id="loading-s4"></div>
                  <div class="alert alert-error" v-if="showError">
                    <p class="alert-title">
                      {{ $t("LOGINS4").Error_Message_Title }}
                    </p>
                    <p class="alert-title">{{ errorContent }}</p>
                    <!-- Atendimento -->
                    <div>
                      <div class="box box-info-icon">
                        <feather-icon
                          class="mr-0 cursor-pointer"
                          icon="PhoneCallIcon"
                        />
                        {{ $t("HELP_ATTENDANCE").Phone }}
                        <a href="tel:+5501130532750">(11) 3053-2750</a>
                      </div>
                      <div class="box box-info-icon">
                        <feather-icon
                          class="mr-0 cursor-pointer"
                          icon="MailIcon"
                        /><a href="mailto:atendimento@cma.com.br"
                          >atendimento@cma.com.br</a
                        >
                      </div>
                    </div>
                    <!-- Fim atendimento -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import authService from "../../providers/authService";
import messagesNotifyHelper from "../../helpers/messages-notify-helper";
import AppConstants from "@/appConstants";
import { EventBus } from "../../event-bus";

export default {
  data() {
    return {
      errorContent: this.$t("LOGINS4").Error_Message_Content,
      showError: false,
      lostAccessLink: AppConstants.NAVIGATION_PAGE_LOST_ACCESS,
    };
  },
  mounted() {
    const error = this.$route.query.error;
    if (error && error === AppConstants.ERROR_S4_TOKEN) {
      this.errorContent = this.$t("LOGINS4").Error_Message_Content_Other_Login;
      this.showError = true;
    } else {
      this.$vs.loading({
        container: "#loading-s4",
        scale: 0.6,
      });

      this.token = this.$route.query.token;
      this.sendLogin();
    }
    EventBus.$emit("onS4Login");
    console.log("teste", this.$store.state.insetTop);
  },
  methods: {
    sendLogin() {
      const form = {
        token: this.token,
      };

      authService
        .S4login(form, new URLSearchParams())
        .then((response) => {
          // response[0].email = this.email;
          authService.successLogin(response, true);

          // redirect url
          // console.log(this.$route.query);
          const routeQuery = Object.keys(this.$route.query).filter(
            (q) => q !== "to"
          );
          const routePath = {
            path: this.$route.query.to ? this.$route.query.to : "/",
          };

          if (routeQuery) {
            routePath.query = {};
            routeQuery.forEach((key) => {
              routePath.query[key] = this.$route.query[key];
            });
          }

          this.$router.push(routePath);
        })
        .catch((error) => {
          this.$vs.loading.close("#loading-s4 > .con-vs-loading");
          this.showError = true;
        });
    },
    onLogin() {
      this.showErrors = true;

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.sendLogin();
        } else {
          messagesNotifyHelper.errorNotify(
            this.$t("LOGIN").Notify_Error_Title,
            this.$t("LOGIN").Notify_Error_Message
          );
        }
      });
    },
  },
};
</script>

<style lang="scss">
button.vs-component.vs-button.btn-login.vs-button-primary.vs-button-filled {
  width: 100%;
  background-color: #00663a !important;
}

.content-login {
  margin: 30px;
}

.title-box-login {
  font-weight: 600;
}

.box-login {
  width: 830px !important;
  height: 425px;
}

@media (max-width: 520px) {
  .full-page-bg-color {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
  }
}

.alert {
  width: 100%;
  padding: 12px 16px;
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  margin-bottom: 12px;
  font-size: 14px;
}

.alert.alert-error {
  background-color: rgba(248, 215, 218, 1);
  border-color: rgba(220, 53, 69, 1);
  color: rgba(114, 28, 36, 1);
}
.alert-title {
  margin-bottom: 10px;
}
a.support {
  color: #9e4747;
  font-weight: bold;
}

.box {
  margin-bottom: 10px;
}
.box.box-info-icon {
  padding-left: 30px;
}
.box.box-info-icon span svg {
  position: absolute;
  margin-top: -4px;
  margin-left: -30px;
  color: rgba(114, 28, 36, 1);
  font-weight: bold;
}
a {
  color: rgba(114, 28, 36, 1);
}
</style>
